var map = {
	"./photo1.jpg": 9219,
	"./photo10.jpeg": 1371,
	"./photo11.jpeg": 903,
	"./photo12.jpeg": 1628,
	"./photo13.jpeg": 4758,
	"./photo14.jpg": 8862,
	"./photo15.jpeg": 285,
	"./photo16.png": 9674,
	"./photo2.png": 79,
	"./photo3.jpeg": 3177,
	"./photo4.jpg": 470,
	"./photo5.jpg": 2784,
	"./photo6.jpg": 5799,
	"./photo7.jpeg": 2189,
	"./photo8.jpg": 116,
	"./photo9.jpg": 1773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9737;